<template>
    <v-row no-gutters>

        <v-col>

            <v-card>
                <v-toolbar dense>
                    <v-toolbar-title>Edit Company</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"
                           :disabled="!!errors.items.length || !formValidated"
                           @click="submit">Save
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <form>
                        <v-text-field
                                v-model="form.name"
                                v-validate="'required|min:1'"
                                :error-messages="errors.collect('form.name')"
                                label="Name"
                                data-vv-name="form.name"
                                data-vv-as="Name"
                                required
                        ></v-text-field>

                        <v-text-field
                                label="Domain"
                                v-validate="''"
                                v-model="form.domain"
                                :error-messages="errors.collect('form.domain')"
                                data-vv-name="form.domain"
                                data-vv-as="Domain"
                        ></v-text-field>
                        <v-text-field
                                label="Phone"
                                v-validate="''"
                                v-model="form.phone"
                                :error-messages="errors.collect('form.phone')"
                                data-vv-name="form.phone"
                                data-vv-as="Phone"
                        ></v-text-field>
                    </form>

                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
</template>

<script>
	export default {
		data: () => ({
			form: {
				name: '',
				domain: '',
				phone: ''
			},
            users_count: 0
		}),
		mounted() {
			this.getCompany()
		},
		computed: {
			formValidated() {
				return Object.keys(this.fields).some(key => this.fields[key].validated) &&
					Object.keys(this.fields).some(key => this.fields[key].valid)
			}
		},
		methods: {
			async submit() {
				if (await this.$formValidator.validate(this.form)) {
					try {
						await this.$http.put(`/companies/${this.$route.params.id}`, this.form)
						this.$router.push('/companies')
					} catch (e) {
						this.$validationException(e)
					}
				}
			},
			async getCompany() {
				const {data} = await this.$http.get(`/companies/${this.$route.params.id}`, {
					params: {
						include: 'users_count',
					}
				})
				this.form.name = data.name
				this.form.domain = data.domain
				this.form.phone = data.phone
				this.users_count = data.users_count
			},
		}
	}
</script>

<style scoped>

</style>
